// extracted by mini-css-extract-plugin
export var backgroundImage = "ContactForm-module--backgroundImage--RkJaw";
export var contact = "ContactForm-module--contact--WfbWs";
export var contactImage = "ContactForm-module--contactImage--0of2+";
export var contactPhoto = "ContactForm-module--contactPhoto--D3wtr";
export var form = "ContactForm-module--form--UjVfc";
export var submit = "ContactForm-module--submit--GEain";
export var wrapper = "ContactForm-module--wrapper--iXJA2";